module.exports = __webpack_public_path__ + "assets/img/tg-manager.f79d5f28.png";